import { creationDelay, isAssociation, PROCEDURES } from "./creationFlow";

// Labels used to display requests in the dashboard spaces

export const REQUEST_TYPES = {
  RegistrationRequest: "Création d'entreprise",
  CriminalRecordRequest: "Extrait de casier judiciaire",
  NationalityCertificateRequest: "Certificat de nationalité",
  CelibacyCertificateRequest: "Certificat de célibat",
  PassportEnrollmentRequest: "Pré-enrôlement passeport",
  EneoRequest: "Branchement ENEO",
  CustomsRebateRequest: "Abattement douanier",
  BusinessPlanRequest: "Business plan",
  ImportationRequest: "Inscription au fichier des importateurs",
  OapiRequest: "Protection du nom à l'OAPI",
  VisualIdentityRequest: "Identité visuelle",
  TrademarkRequest: "Protection de la marque à l'OAPI",
  TaxRegistrationRequest: "Attestation d'immatriculation (NIU)",
  TaxComplianceRequest: "Attestation de conformité fiscale",
  CnpsRegistrationRequest: "Immatriculation à la CNPS",
  DomiciliationRequest: "Domiciliation",
  AdminRequest: "Administration",
  JuridiqueRequest: "Suivi juridique",
  OdooRequest: "Gestion 360",
};

export const requestTitle = (request) => {
  if (request?.type === "RegistrationRequest") {
    return isAssociation(request.businessType)
      ? "Création d'une association"
      : `Création d'une ${request.businessType || "entreprise"}`;
  }

  return REQUEST_TYPES[request?.type] || "Démarche";
};

export const SERVICE_NAMES = {
  registration: "Création d'entreprise",
  name_registration: "Recherche du nom",
  domiciliation: "Domiciliation",
  admin: "Administration",
  juridique: "Suivi juridique",
  management: "Facturation (Gestion 360)",
  grh: "Ressources humaines (Gestion 360)",
  sales: "Relation client (Gestion 360)",
  odoo: "Gestion 360 (ERP)",
  oapi: "Protection du nom à l'OAPI",
  bank_account_registration: "Ouverture de compte bancaire",
  logo: "Logo",
  business_cards: "Cartes de visite",
  brochures: "Plaquettes",
  company_stamp: "Cachets de l'entreprise",
  oapi_trademark: "Protection de la marque à l'OAPI",
  tax_registration: "Attestation d'immatriculation (NIU)",
  tax_compliance: "Attestation de conformité fiscale",
  cnps_registration: "Immatriculation à la CNPS",
};

const BILLING_LABELS = {
  monthly: "mensuel",
  yearly: "annuel",
};

// "Cartes de visite × 200", "Domiciliation (mensuel)"...
export const serviceLabel = (service) => {
  const name = SERVICE_NAMES[service?.code] || service?.code || "";

  if (service?.quantity) return `${name} × ${service.quantity}`;
  if (BILLING_LABELS[service?.billing]) {
    return `${name} (${BILLING_LABELS[service.billing]})`;
  }

  return name;
};

// "Express · environ 3 jours", or the fixed delay of an association
export const procedureLabel = (request) => {
  if (!request?.businessType) return null;

  const { businessType, procedure } = request;

  if (isAssociation(businessType)) return creationDelay(businessType);

  const label = PROCEDURES[procedure]?.label || PROCEDURES.classic.label;

  return `${label} · ${creationDelay(businessType, procedure).toLowerCase()}`;
};
